<template>
  <div class="service-form-part">
    <DormerMaterialRadioField
      ref="dormerMaterial"
      :choices="choices"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import DormerMaterialRadioField from 'chimera/all/components/form/fields/dormerMaterial/DormerMaterialRadioField'
import { Selectable } from 'chimera/all/components/models/Selectable'

export default {
  name: 'DormerMaterialRadioFormPart',

  components: {
    DormerMaterialRadioField,
  },

  /**
   * @returns {{choices: Selectable[]}}
   */
  data() {
    return {
      choices: [
        new Selectable(
          'Kunststof dakkapel',
          'Kunststof dakkapel',
          'Kunststof dakkapel',
        ),
        new Selectable(
          'Houtlook dakkapel',
          'Houtlook dakkapel',
          'Houtlook dakkapel',
        ),
        new Selectable(
          'Dakkapel van hout',
          'Dakkapel van hout',
          'Dakkapel van hout',
        ),
        new Selectable('Weet ik niet', 'Weet ik niet', 'Weet ik niet'),
      ],
    }
  },
}
</script>
